import { AdvisorsLayout, SessionBookSection } from '@src/components/sco/Advisors'
import { advisorsBookSeo } from '@src/components/sco/Advisors/utils/advisorsSeo'
import { usePageSEO } from '@src/hooks/usePageSEO'

export { getServerSideProps } from '@src/lib/server-side-rendering'

/** Guests get the same booking form in place (L3/L12). Always `noindex` (L2). */
export default function Page() {
  usePageSEO(advisorsBookSeo())

  return (
    <AdvisorsLayout>
      <SessionBookSection />
    </AdvisorsLayout>
  )
}
